import React from "react";
import * as echarts from "echarts/core";
import ReactEcharts from "echarts-for-react";
import ReactEChartsCore from "echarts-for-react/lib/core";
// import ReactEChartsCore from 'echarts-for-react/lib/core';
// import * as echarts from 'echarts/core';
import { BarChart } from "echarts/charts";

const Bar = (props) => {
  const { Workflow, Print, Rule, Plugin, model, getLangMsg } = props
  echarts.use([BarChart]);
  let colorList = [
    "#326CEF",
    "#3BB2CA",
    "#FF7675",
    "#038AD7",
  ];
  const getOption = {
    grid: {
    },
    dataset: {
      source: [
        [getLangMsg('modelBar.key0001'), Workflow],
        [getLangMsg('modelBar.key0002'), Print],
        [getLangMsg('modelBar.key0003'), Rule],
        [getLangMsg('modelBar.key0004'), Plugin],
      ],
    },
    xAxis: [{
      type: "value",
      axisTick: { // 坐标轴刻度线 
        lineStyle: {
          type: 'dashed',
          color: 'green',
        }
      },
      axisLine: { //坐标轴
        show: false,
      },
      splitLine: { // 网格线
        show: true,
        lineStyle: {
          color: '#333B5E',
        }
      },
      axisLabel: { //坐标轴样式
        verticalAlign: 'middle',
      },
    }],
    yAxis: {
      type: "category",
      // boundaryGap: false,
      // nameLoctaion: [250,-25],
      axisTick: { // 坐标轴刻度线 
        show: false,
        alignWithLabel: true,
        // offset: 20
      },
      axisLabel: { //坐标轴样式
        onZero: true,
        color: '#ffffff',
        align: 'left',
        verticalAlign: 'bottom',
        padding: 8,
        margin: -8,
        fontSize: 14,
        opacity: 0.6,
        fontFamily: 'MicrosoftYaHei',
        lineStyle: {
          cap: 'butt'
        }
        // offset: 20
      },
    },
    series: {
      type: "bar",
      // barCategoryGap: '50%',
      barWidth: 16,
      barCategoryGap: '30%',
      showBackground: true,
      backgroundStyle: {
        color: "#2e5384"
      },
      itemStyle: {
        // 定制显示（按顺序）,实现不同颜色的柱体
        color: (params) => {
          return colorList[params.dataIndex];
        },
      },
      label: {
        show: true,
        position: [370,-27],
        fontSize: 28,
        fontWeight: 700,
        color: '#ffffff'
      },
      // barCategoryGap: '50%'
    },
  };
  return (
    <>
      <ReactEChartsCore
        echarts={echarts}
        style={{
          height: "100%",
          width: "100%",
        }}
        option={getOption}
      />
    </>
  );
  //    }
};

export default Bar;
